<template>
  <d-container fluid class="main-content-container px-4">
    <div class="page-header row no-gutters py-4">
      <div class="d-flex justify-content-between no-gutters col-12 mr-0">

        <div class="col-3 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Order Page</span>
          <h3 class="page-title">Overview</h3>
        </div>

        <div class="col-9 d-flex justify-content-end align-items-end">
          <d-select v-model="d_selectedOption" :options="d_options" class="col-4"></d-select>
          <div class="col-2 text-right mb-2">Filter by:</div>
          <d-select class="col-3 mr-2" v-model="d_selectedFilter" :options="d_filterColumn" ></d-select>
          <d-input class="col-3" v-model="d_searchQuery" name='searchField' type="text" placeholder="filter orders" @change="onSearch"></d-input>
        </div>

      </div>
    </div>
    <d-card>
      <d-card-body class="p-0">
          <table class="table table-hover mb-0">
            <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0"><span :class="setCss('reference')" @click="filterbyColumn('reference')">Reference</span></th>
              <th scope="col" class="border-0"><span :class="setCss('orderDate')" @click="filterbyColumn('orderDate')">Ordered at</span></th>
              <th scope="col" class="border-0"> <span :class="setCss('departureDate')" @click="filterbyColumn('departureDate')" >Departure date </span></th>
              <th scope="col" class="border-0"><span :class="setCss('name')" @click="filterbyColumn('name')">Fullname</span></th>
              <th scope="col" class="border-0">Provider</th>
              <th scope="col" class="border-0">Language</th>
              <th scope="col" class="border-0">Status</th>
              <th scope="col" class="border-0"><span :class="setCss('price')" @click="filterbyColumn('price')">Price</span></th>
              <th scope="col" class="border-0"><span>Voucher</span></th>
            </tr>
            </thead>

            <tbody>
            <template v-for="order in d_orders">
              <tr @click="onSelectOrder(order.id)" class="">
                <td style="vertical-align: middle;">
                  {{order.reference}}
                </td>
                <td style="vertical-align: middle;">{{dateFormat(order.createdAt)}}&nbsp;{{timeFormat(order.createdAt)}}</td>
                <td style="vertical-align: middle;">{{dateFormat(order.from)}}</td>
                <td style="vertical-align: middle;">
                  {{order.lastName}}, {{order.firstName}}<br>
                </td>
                <td>{{  order.providerName  }}</td>
                <td>{{  (order.language.toUpperCase() ) }}</td>
                <td style="vertical-align: middle;">
                  <d-badge :class="showStatusFeedback(order.status)">{{order.status}}</d-badge>
                </td>

                <td style="vertical-align: middle;">{{formatCurrency(order.price.currency, order.price.amount)}}</td>
                <td>
                  <a v-if="order.voucher !== null" :href="order.voucher.url"><i class="fa fa-download mr-2"></i></a>
                  <span v-else >--</span>
                </td>
              </tr>
            </template>
            </tbody>
          </table>

      </d-card-body>

      <v-pagination
        v-on:goToPage="goToPage($event)"
        ref="pagination"
        :totalItems="d_totalOrders"
        :activePage="d_currentPage"
        :totalPage="d_totalPage">
      </v-pagination>

    </d-card>
  </d-container>
</template>

<script>

  import Utils from '../../utils'

	export default {
		name: "Overview",

    data: function () {
      return {
        d_currentPage: 1,
        d_totalPage: 25,
        d_search: '',
        d_orders: [],
        d_allOrders: [],
        d_priceSortASC: false,
        d_nameASC: false,
        d_statusASC: false,
        d_productASC: false,
        d_dateASC: false,
        d_orderDateASC: false,
        d_referenceASC: false,
        d_activeColumn: 'order',
        d_options: [ {text: 'All', value:'UNDETERMINED'}, {text: 'Completed', value: 'COMPLETED'}, {text: 'Cancelled', value: 'CANCELLED'}, {text: 'Pending', value: 'PENDING'}],
        d_selectedOption: 'COMPLETED',
        d_totalOrders: 0,
        d_filterColumn: [ {text: 'Reference', value:'ref'}, {text: 'Email', value:'email'}, {text: 'Language', value:'language'}, {text: 'LicensePlate', value:'licensePlate'}],
        d_selectedFilter: 'ref',
        d_sortedBy: 'created_at', // Options: sortBy full_name, first_name, last_name, created_at, from, to, reference, amount
        d_sorting: '',
        d_direction: 'Descending', // Options: Ascending, Descending
        d_searchQuery: "",
      }
    },

    mounted () {
      this.getGQLData()
      this.setCss('orderDate')
    },

    methods: {

		  onSearch: function() {
		    this.d_currentPage = 1
        this.$refs.pagination.resetPage()
        this.getGQLData()
      },

		  getGQLData: function() {

		    const variables = {
		      filter: {
            email: null,
            reference: null,
            language: null,
            licensePlate: null,
            status: this.d_selectedOption.toUpperCase(),
          },
          pagination: {
		        limit:  25,
            page: this.d_currentPage
          },
          sorting: {
		        sortBy: this.d_sortedBy,
            direction: this.d_direction
          }
		    }

        if (this.d_selectedFilter === 'ref') variables.filter.reference = this.d_searchQuery
        if (this.d_selectedFilter === 'email') variables.filter.email = this.d_searchQuery
        if (this.d_selectedFilter === 'language') variables.filter.language = this.d_searchQuery
        if (this.d_selectedFilter === 'licensePlate') variables.filter.licensePlate = this.d_searchQuery

        try {
          this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: require('@/graphql/orders/GetOrders.gql'),
            variables
          }).then(data => {

            this.d_totalOrders = data.data.ordersCount
            this.d_orders = data.data.orders

            this.d_orders.map(item => {
              item.providerName = 'Mobian'
              if(item.service !== null && item.service.provider !== null && item.service.provider.name !== null) {
                item.providerName = item.service.provider.name
              }
            })
          })
        } catch(error) {
          console.log(error)
        }
      },

      onSelectOrder: function ($event) {
        this.$router.push({
          params: {
            id: $event,
          },
          name: 'orders.single',
        });
      },

      formatCurrency: function(currency, value) {
        return new Intl.NumberFormat('nl-NL', {style: 'currency', currency}).format(value);
      },

      dateFormat: function(date) {
        let formatedDate = new Date(Date.parse(date))
        return  formatedDate.getDate() + '-' +  (formatedDate.getMonth()+1)   + '-' +   formatedDate.getFullYear()
      },
      timeFormat(date){
        let d = new Date(date)
        var options = { hour12: false, hour: '2-digit', minute: '2-digit' };
        let formatedTime = d.toLocaleTimeString("en-US", options)
        return formatedTime
      },

      filterbyColumn: function(column) {

        this.d_currentPage = 1;
        column.toLowerCase();

        switch (column) {

          case 'name':
            this.d_nameASC = !this.d_nameASC;
            (this.d_nameASC) ? this.d_direction = 'Ascending' : this.d_direction = 'Descending'
            this.d_sortedBy = 'full_name'
            break;

          case 'reference':
            this.d_referenceASC = !this.d_referenceASC;
            (this.d_referenceASC) ? this.d_direction = 'Ascending' : this.d_direction = 'Descending'
            this.d_sortedBy = 'reference'
            break;

          case 'orderDate':
            this.d_orderDateASC = !this.d_orderDateASC;
            (this.d_orderDateASC) ? this.d_direction = 'Ascending' : this.d_direction = 'Descending'
            this.d_sortedBy = 'created_at'
            break;

          case 'departureDate':
            this.d_orderDateASC = !this.d_orderDateASC;
            (this.d_orderDateASC) ? this.d_direction = 'Ascending' : this.d_direction = 'Descending'
            this.d_sortedBy = 'from'
            break;

          case 'price':
            this.d_priceSortASC = !this.d_priceSortASC;
            (this.d_priceSortASC) ? this.d_direction = 'Ascending' : this.d_direction = 'Descending'
            this.d_sortedBy = 'amount'
            break;
        }

        this.d_activeColumn = column
        this.getGQLData()

      },

      setCss: function (column) {
        let css = 'sortable both'

        if(this.d_activeColumn === column) {
          switch (column) {

            case 'name':
              (this.d_nameASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;

            case 'reference':
              (this.d_referenceASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;

            case 'product':
              (this.d_productASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;

            case 'status':
              (this.d_statusASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;

            case 'date':
              (this.d_dateASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;

            case 'orderDate':
              (this.d_orderDateASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;
            
            case 'departureDate':
              (this.d_orderDateASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;  

            case 'price':
              (this.d_priceSortASC) ? css = 'sortable asc' : css = 'sortable desc'
              break;
          }
        }
        return css;
      },

      goToPage: function (id) {
        this.d_currentPage = id
        this.getGQLData();
      },

      showStatusFeedback: function(status) {

        let theme = 'badge mr-1 ';
        if (status.toLowerCase() === 'pending') {
          theme = 'badge-warning';
        } else if (status.toLowerCase() === 'completed') {
          theme = 'badge-success';
        } else if (status.toLowerCase() === 'cancelled') {
          theme = 'badge-danger';
        } else if (status.toLowerCase()=== 'undetermined') {
          theme = 'badge-primary';
        }
        return theme;
      },

    },

    watch: {
      d_selectedOption: function() {
        this.getGQLData()
      },
    },

	}
</script>
